/**
 * @fileoverview Infinite Photo Carousel Utility, customized for Sanderson Farms
 * @author david@blackairplane.com (David Leggett)
 * @copyright Black Airplane 2021
 */

import SfPhotoModal from './SfPhotoModal'

class SfPhotoCarousel {
    constructor(el) {
        this.el = el
        this.sliderEl = el.querySelector('.sf-photo-carousel__slider')
        this.slideEls = []
        this.slideCount = 0
        this.slidesEl = el.querySelector('.sf-photo-carousel__slides')
        this.duplicatedSlides = []
        this.prevButton = el.querySelector('.sf-photo-carousel__nav-button--prev')
        this.nextButton = el.querySelector('.sf-photo-carousel__nav-button--next')
        this.currentSlide = 0
        this.mobileMargin = 8
        this.desktopMargin = 16
        this.margin = 0
        this.containerWidth = 0
        this.viewportWidth = 0
        this.mobileSlideWidth = 168
        this.desktopSlideWidth = 229
        this.slideWidth = 0
        this.showInstagramLogo = parseInt(el.dataset.showInstagram)

        this.modal = new SfPhotoModal()

        this.init()
    }

    init () {
        this.slideEls = this.el.querySelectorAll('.sf-photo-carousel__slide');
        this.slideCount = this.slideEls.length

        for(let i = 0; i < 3; i++) {
            this.slideEls.forEach(slide => {
                const cloneEl = slide.cloneNode(true)
                this.duplicatedSlides.push(cloneEl)
            })
        }

        // Replace the initial slides with the duplicated ones
        this.slidesEl.innerHTML = '';
        this.duplicatedSlides.forEach(slide => {
            this.slidesEl.appendChild(slide)

            slide.addEventListener('click', () => {
                this.openModal(slide)
            })
        })

        this.setupSlides()

        this.nextButton.addEventListener('click', () => {
            this.nextSlide()
        })

        this.prevButton.addEventListener('click', () => {
            this.prevSlide()
        })

        window.addEventListener('resize', () => {
            this.setupSlides()
        })
    }

    openModal(slide) {
        const content = JSON.parse(slide.dataset.content)
        const photo = slide.dataset.photo
        const title = slide.dataset.title

        this.modal.openModal(photo, content.content, title, this.showInstagramLogo)
    }

    stopAnimation () {
        this.el.classList.add('sf-photo-carousel--no-animation')
    }

    startAnimation () {
        this.el.classList.remove('sf-photo-carousel--no-animation')
    }

    setupSlides () {
        this.viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

        this.containerWidth = this.el.offsetWidth

        if (this.viewportWidth >= 768) {
            this.slideWidth = this.desktopSlideWidth
            this.margin = this.desktopMargin
        } else {
            this.slideWidth = this.mobileSlideWidth
            this.margin = this.mobileMargin
        }

        this.setSlidePositions()
        this.setSlideStyles()
    }

    setSlideStyles () {
        Object.assign(this.slidesEl.style, this.slidesElStyles())
    }

    setSlidePositions () {
        this.duplicatedSlides.forEach((slideEl, index) => {
            Object.assign(slideEl.style, this.slideStyle(index))
        })
    }

    prevSlide () {
        if (this.currentSlide === 0) {
            this.stopAnimation()
            this.currentSlide = this.slideCount
            this.setSlideStyles()
            window.getComputedStyle(this.slidesEl).opacity
            this.startAnimation()
            this.currentSlide = this.slideCount - 1
            window.getComputedStyle(this.slidesEl).opacity
        } else {
            this.currentSlide--
        }

        this.setSlideStyles()
    }

    nextSlide () {
        if (this.currentSlide + 1 >= this.slideCount) {
            this.stopAnimation()
            this.currentSlide = -1
            this.setSlideStyles()
            window.getComputedStyle(this.slidesEl).opacity
            this.startAnimation()
            this.currentSlide = 0
            window.getComputedStyle(this.slidesEl).opacity
        } else {
            this.currentSlide++
        }

        this.setSlideStyles()
    }

    slideStyle (index) {
        const offset = (index * this.slideWidth) + ((index) * this.margin) + (this.containerWidth / 2)

        if (index === this.actualIndex()) {
            // actual index styles
        } else if (Math.abs(index - this.actualIndex()) > 1) {
            // not the active index styles
        }

        return {
            left: offset + 'px'
        }
    }

    transformSliderAmount () {
        return ((this.actualIndex()) * this.slideWidth) + ((this.actualIndex()) * this.margin) + (this.slideWidth / 2)
    }

    slidesElStyles () {
        const width = ((this.duplicatedSlides.length - 1) * this.slideWidth) + ((this.duplicatedSlides.length - 1) * this.margin) + this.slideWidth + (this.containerWidth / 2)

        return {
            width: width + 'px',
            transform: `translateX(-${this.transformSliderAmount()}px)`
        }
    }

    actualIndex () {
        return this.slideCount + this.currentSlide
    }
}

export default SfPhotoCarousel;
